import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Checkout2Component } from './checkout2/checkout2.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';

@NgModule({
  declarations: [Checkout2Component],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  exports: [Checkout2Component],
})
export class FeatureCheckout2Module {}
